/*
  ===================================================================
  nx-lineup-v2.js — ホームLINE UP刷新 (2026-07-20)
  1. 3Dリングカルーセル: naturism-category.js (2026-07-04) の移植。
     常時表示(トグルなし)・入場はIOでライン単位stagger。
  2. 診断モーダル: 9問版(2026-07-20オーナー仕様)。
     ⚠️2026-07-25訂正: /collections(naturism-category.js)も同じ9問・同一configで、
     以前の「5問版とは独立」というコメントは誤り。設問/採点を変える時は両方を同時更新すること。
  ⚠️リング挙動を変える時は naturism-category.js 側との整合に注意
     (ライブAtlantic共有につき向こうは直接編集不可)。
  依存ライブラリなし。html.nxl-js が付与された時のみ拡張が有効
  (JS無効時はCSS側の静的グリッド + 素の<a>で購入可能)。
  ===================================================================
*/
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (window.Shopify && Shopify.designMode) return; /* エディタ=CSS静的グリッド(WYSIWYG) */
  /* JSが実際に動く時のみ nxl-js を付与(エディタ/読込失敗時は html:not(.nxl-js) の
     静的グリッドが生きる=セクション不可視バグの構造的防止。初期ビューポート外のためFOUCなし) */
  document.documentElement.classList.add('nxl-js');

  function track(name, params) {
    try {
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params || {}));
    } catch (e) {}
  }

  /* ============================================================
     1. 診断 — 9問版(2026-07-20オーナー仕様)
        ⚠️/collections(naturism-category.js)と同一config(2026-07-25実測: 9問・選択肢も一致)。
        片方だけ変えると出し分けが壊れるため必ず同時更新
        Q1,Q3-Q8=加点 / Q2=料理順位付け(1位+2,2位+1,3位+1) / Q9=加点なし(同点処理のみ)
     ============================================================ */
  var QTYPES = ['blue', 'pink', 'premium']; /* 度数バーは必ずこの固定順で表示 */
  var TYPE_LABELS = { blue: 'ブルー度', pink: 'ピンク度', premium: 'プレミアム度' };
  var QUESTIONS = [
    {
      id: 1,
      text: 'Q1. 普段の食事の傾向は?',
      kind: 'single',
      options: [
        { label: '揚げ物・脂っこい料理が好き', pts: { pink: 0, blue: 2, premium: 2 } },
        { label: 'ご飯・パン・麺類が多い', pts: { pink: 1, blue: 0, premium: 2 } },
        { label: 'バランスを意識', pts: { pink: 2, blue: 1, premium: 0 } },
        { label: '外食やコンビニ中心', pts: { pink: 0, blue: 1, premium: 2 } },
      ],
    },
    {
      id: 2,
      text: 'Q2. 好きな料理は? 1位〜3位の順にタップしてください',
      kind: 'rank',
      options: ['和食', '中華', '焼肉', 'イタリアン', 'ラーメン／麺類'],
    },
    {
      id: 3,
      text: 'Q3. 体型管理の目標は?',
      kind: 'single',
      options: [
        { label: '体重を落としたい', pts: { pink: 0, blue: 1, premium: 2 } },
        { label: '体型を維持したい', pts: { pink: 1, blue: 2, premium: 0 } },
        { label: '健康のため', pts: { pink: 1, blue: 0, premium: 2 } },
        { label: '美容のため', pts: { pink: 1, blue: 0, premium: 2 } },
      ],
    },
    {
      id: 4,
      text: 'Q4. 食事のリズムで当てはまるのは?',
      kind: 'single',
      options: [
        { label: '外食・会食がとても多い', pts: { pink: 1, blue: 3, premium: 2 } },
        { label: '食事の時間が不規則になりがち', pts: { pink: 0, blue: 2, premium: 1 } },
        { label: '自炊中心・今の食習慣を保ちたい', pts: { pink: 1, blue: 1, premium: 0 } },
        { label: '特に悩みはない', pts: { pink: 1, blue: 0, premium: 0 } },
      ],
    },
    {
      id: 5,
      text: 'Q5. 続けるうえで重視したいのは?',
      kind: 'single',
      options: [
        { label: '美容も一緒に考えたい', pts: { pink: 3, blue: 0, premium: 0 } },
        { label: '食事の量が多くなりがち', pts: { pink: 0, blue: 2, premium: 1 } },
        { label: '全体的にケアしたい', pts: { pink: 0, blue: 0, premium: 3 } },
        { label: '特になし', pts: { pink: 1, blue: 0, premium: 0 } },
      ],
    },
    {
      id: 6,
      text: 'Q6. 甘いもの・間食の頻度は?',
      kind: 'single',
      options: [
        { label: 'ほぼ毎日食べる', pts: { pink: 0, blue: 1, premium: 3 } },
        { label: '週に数回', pts: { pink: 0, blue: 0, premium: 2 } },
        { label: 'たまに', pts: { pink: 1, blue: 1, premium: 0 } },
        { label: 'ほとんど食べない', pts: { pink: 2, blue: 0, premium: 0 } },
      ],
    },
    {
      id: 7,
      text: 'Q7. 運動の習慣は?',
      kind: 'single',
      options: [
        { label: 'ほとんど運動しない', pts: { pink: 0, blue: 1, premium: 2 } },
        { label: '軽く歩く程度', pts: { pink: 1, blue: 1, premium: 0 } },
        { label: '週1〜2回運動する', pts: { pink: 1, blue: 1, premium: 0 } },
        { label: 'しっかり運動している', pts: { pink: 2, blue: 0, premium: 0 } },
      ],
    },
    {
      id: 8,
      text: 'Q8. 続けやすさ・価格の考え方は?',
      kind: 'single',
      options: [
        { label: 'まずは手軽に・コスパ重視', pts: { pink: 1, blue: 2, premium: 0 } },
        { label: '効果重視でしっかり投資したい', pts: { pink: 0, blue: 0, premium: 3 } },
        { label: '1日55円〜150円くらいなら特に気にならない', pts: { pink: 1, blue: 0, premium: 2 } },
        { label: '根拠(機能性表示食品など)があるものがいい', pts: { pink: 0, blue: 0, premium: 2 } },
      ],
    },
    {
      id: 9,
      text: 'Q9. naturism を試すのは?',
      kind: 'single',
      options: [
        { label: '初めて', pts: null },
        { label: '飲んだことある', pts: null },
        { label: '今飲んでいて別種類を検討中', pts: null },
      ],
    },
  ];
  var Q2_CUISINE_TYPE = { 和食: 'pink', イタリアン: 'pink', 中華: 'blue', 焼肉: 'blue', 'ラーメン／麺類': 'premium' };
  var Q2_RANK_POINTS = [2, 1, 1]; /* 1位,2位,3位 */

  var LINE_META = {
    blue: {
      name: 'naturism Blue',
      desc: '脂っこい食事や外食が多いあなたには、黒烏龍茶で「食べたあと」をケアするブルーがぴったり。',
    },
    pink: {
      name: 'KOSO in naturism Pink',
      desc: '美容やバランスを大切にするあなたには、酵素で内側からととのえるピンクがぴったり。',
    },
    premium: {
      name: 'naturism Premium',
      desc: '糖質も脂質もしっかりケアして結果を出したいあなたには、トータルケアのプレミアムがぴったり。',
    },
  };
  /* 結果→比較ガイドの該当シリーズへ(アンカーIDはne-x-compare.liquidの実IDと一致を確認済み) */
  var COMPARE_URLS = {
    blue: '/pages/compare#nxcp-blue',
    pink: '/pages/compare#nxcp-pink',
    premium: '/pages/compare#nxcp-premium',
  };

  /* answers: 質問index順の配列。single=選択肢index / rank=料理ラベル3件の配列 */
  function scoreQuiz(answers) {
    var s = { blue: 0, pink: 0, premium: 0 };
    QUESTIONS.forEach(function (q, i) {
      var a = answers[i];
      if (a == null) return;
      if (q.kind === 'rank') {
        a.forEach(function (label, r) {
          var t = Q2_CUISINE_TYPE[label];
          if (t) s[t] += Q2_RANK_POINTS[r] || 0;
        });
      } else {
        var pts = q.options[a] && q.options[a].pts;
        if (pts) {
          s.blue += pts.blue || 0;
          s.pink += pts.pink || 0;
          s.premium += pts.premium || 0;
        }
      }
    });
    /* 同点処理(決定的): Q9=初めて → blue>pink>premium / それ以外 → premium>blue>pink */
    var first = answers[8] === 0;
    var prio = first ? ['blue', 'pink', 'premium'] : ['premium', 'blue', 'pink'];
    var max = Math.max(s.blue, s.pink, s.premium);
    var rec = prio.filter(function (t) {
      return s[t] === max;
    })[0];
    return { rec: rec, scores: s };
  }

  /* ============================================================
     2. 3Dリングカルーセル (naturism-category.js の移植)
     ============================================================ */
  var rings = {};

  /* ---- アイドル自動回転(2026-07-22 提案②) ----
     4秒無操作+非ホバー+非キーボードフォーカス+可視+タブ前面+
     他アニメ(raf)停止中のリングだけをリズム式(6秒90°+2秒静止)で回す。
     モバイルにも同仕様で適用(2026-07-22オーナー指示。タッチはhover休止が無い分、
     pointerenterをマウス限定にして誤休止を防ぐ)。REDUCED/エディタは無効 */
  var autoVis = null;
  var AUTOROT = !REDUCED;
  if (AUTOROT && 'IntersectionObserver' in window) {
    autoVis = new IntersectionObserver(
      function (ents) {
        ents.forEach(function (en) {
          if (en.target.__nxlRing) en.target.__nxlRing.visible = en.isIntersecting;
        });
      },
      { threshold: 0.25 },
    );
    /* リズム式回転(2026-07-22改3・オーナー指示): 「6秒で90°左回りスイープ→2秒静止」を繰り返す。
       easeInOutSineで出入りが柔らかい=高級なレイジースーザン。
       中断(ホバー/操作/非可視/タブ裏)したら静止フェーズへ戻し、再開時は最寄りの
       スナップ位置-90°へ掃引(距離比例の短縮時間)=常に前面が定位置へ自己修復。
       front通過時はpaint()内チップポップが発火 */
    var SWEEP_MS = 6000,
      DWELL_MS = 2000;
    /* スクロールも「操作」扱い(codex#63 MED): 特にモバイルは縦スクロール通過中に
       スイープが始まると視界がうるさい→停止後4秒からリズム再開 */
    window.addEventListener(
      'scroll',
      function () {
        var now = performance.now();
        for (var k in rings) if (rings[k]) rings[k].lastUser = now;
      },
      { passive: true },
    );
    var autoPrev = null;
    var autoFrame = function (ts) {
      if (autoPrev === null) autoPrev = ts;
      var dt = Math.min(50, ts - autoPrev);
      autoPrev = ts;
      for (var k in rings) {
        var rg = rings[k];
        if (!rg) continue;
        var eligible =
          !document.hidden &&
          rg.visible &&
          !rg.hovered &&
          !rg.focused &&
          !rg.dragging &&
          !rg.raf &&
          ts - rg.lastUser >= 4000;
        if (!eligible) {
          /* 中断=静止フェーズへ(静止消化済み扱い→再開時すぐスイープ開始) */
          rg.autoPhase = 'dwell';
          rg.autoT = DWELL_MS;
          continue;
        }
        rg.autoT = (rg.autoT || 0) + dt;
        if (rg.autoPhase !== 'sweep') {
          if (rg.autoT < DWELL_MS) continue; /* 静止中 */
          /* スイープ開始: 最寄りスナップ-90°へ(中断明けの半端角も snap へ自己修復) */
          rg.autoFrom = rg.theta;
          rg.autoTarget = Math.round(rg.theta / rg.step) * rg.step - rg.step;
          var dist = Math.abs(rg.autoTarget - rg.autoFrom);
          rg.autoDur = Math.max(800, (SWEEP_MS * dist) / rg.step);
          rg.autoPhase = 'sweep';
          rg.autoT = 0;
          continue;
        }
        var p = Math.min(1, rg.autoT / rg.autoDur);
        var ease = 0.5 - 0.5 * Math.cos(Math.PI * p); /* easeInOutSine */
        rg.theta = rg.autoFrom + (rg.autoTarget - rg.autoFrom) * ease;
        rg.paint();
        if (p >= 1) {
          rg.autoPhase = 'dwell';
          rg.autoT = 0;
        }
      }
      requestAnimationFrame(autoFrame);
    };
    requestAnimationFrame(autoFrame);
  }

  function Ring(stage) {
    var self = this;
    this.stage = stage;
    this.ring = stage.querySelector('[data-nxl-ring]');
    this.track = stage.querySelector('.nxl-ring__track');
    this.cards = Array.prototype.slice.call(stage.querySelectorAll('[data-nxl-card]'));
    this.n = this.cards.length;
    this.step = this.n > 0 ? 360 / this.n : 90;
    /* 初期正面カード(2026-07-26): 既定は0だが、data-nxl-start があればそれを正面にする。
       Premiumは届出H975の対象カードを正面に置くため(セクション側がLiquidで実データ判定)。
       スナップ位置(theta = -index*step)そのものなので自動回転/矢印/ドラッグの計算は不変 */
    var startEl = stage.closest ? stage.closest('[data-nxl-line]') : null;
    var startIdx = startEl ? parseInt(startEl.getAttribute('data-nxl-start') || '0', 10) : 0;
    if (!(startIdx >= 0 && startIdx < this.n)) startIdx = 0;
    this.theta = -startIdx * this.step;
    this.velocity = 0;
    this.dragging = false;
    this.moved = 0;
    this.raf = null;
    this.lastFront = -1; /* チップポップ用(初回paintは発火させない) */
    this.lastUser = performance.now(); /* 自動回転の休止判定 */
    this.hovered = false;
    this.focused = false;
    this.visible = false;
    if (this.n === 0) return;

    var lastX = 0,
      lastT = 0;
    this.ring.addEventListener('pointerdown', function (e) {
      self.dragging = true;
      self.lastUser = performance.now();
      self.moved = 0;
      self.velocity = 0;
      lastX = e.clientX;
      lastT = performance.now();
      /* ⚠️ここで setPointerCapture してはいけない(2026-07-25・実バグ修正)。
         捕捉するとブラウザは以降のポインタイベントを捕捉要素へ再ターゲットするため、
         click の発火先が <a class="nxl-card"> ではなく .nxl-ring になり、
         **アンカーの既定動作(遷移)が一切起きなくなる**(Playwrightで実測:
         click到達先=DIV.nxl-ring / 遷移せず。捕捉を無効化すると即遷移した)。
         捕捉は「実際にドラッグと判定できてから」pointermove側で行う */
      self.pointerId = e.pointerId;
      self.captured = false;
      if (self.raf) {
        cancelAnimationFrame(self.raf);
        self.raf = null;
      }
    });
    this.ring.addEventListener('pointermove', function (e) {
      if (!self.dragging) return;
      var dx = e.clientX - lastX;
      var now = performance.now();
      var dt = Math.max(1, now - lastT);
      self.moved += Math.abs(dx);
      /* ドラッグが成立した時点で初めて捕捉する=指がリング外へ出ても追従し、
         かつ「ただのタップ/クリック」では捕捉が起きないので遷移が生きる */
      if (!self.captured && self.moved > 8) {
        try {
          self.ring.setPointerCapture(e.pointerId);
          self.captured = true;
        } catch (err) {}
      }
      self.theta += dx * 0.35;
      self.velocity = ((dx * 0.35) / dt) * 16; /* deg per frame (60fps基準) */
      lastX = e.clientX;
      lastT = now;
      self.paint();
    });
    var endDrag = function () {
      if (!self.dragging) return;
      self.dragging = false;
      if (self.captured) {
        try {
          self.ring.releasePointerCapture(self.pointerId);
        } catch (err) {}
        self.captured = false;
      }
      self.lastUser = performance.now();
      self.glide();
    };
    this.ring.addEventListener('pointerup', endDrag);
    this.ring.addEventListener('pointercancel', endDrag);

    /* クリック: ドラッグでなければ、前面以外は前面へ回転(遷移させない) */
    this.cards.forEach(function (cardEl, i) {
      cardEl.addEventListener('click', function (e) {
        if (self.moved > 8) {
          e.preventDefault();
          return;
        }
        /* 「正面かどうか」は theta の丸め(frontIndex)ではなく**実際の向き**で判定する
           (2026-07-25): 自動回転のスイープ中は theta が中間値のため frontIndex が
           見た目と食い違い、正面に見えるカードを押しても遷移せず回転だけしていた。
           depth=cos(角度) が 0.55 超(=±約57°以内)なら実質こちらを向いている→素直に遷移させる */
        var depth = Math.cos(((i * self.step + self.theta) * Math.PI) / 180);
        if (depth <= 0.55) {
          e.preventDefault();
          self.rotateTo(i);
        }
      });
      cardEl.setAttribute('draggable', 'false');
    });

    this.ring.addEventListener('keydown', function (e) {
      self.lastUser = performance.now();
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.rotateTo(self.frontIndex() - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.rotateTo(self.frontIndex() + 1);
      } else if (e.key === 'Enter') {
        var front = self.cards[self.frontIndex()];
        self.moved = 0; /* 直前ドラッグの残値でクリックガードが誤爆しないように */
        if (front && document.activeElement === self.ring) front.click();
      }
    });

    /* 左右ナビ矢印(2026-07-22 提案①): クリックで1枚回転(自動回転も4秒休止)。
       向き=ドラッグと同じ「リングを押す」感覚(オーナー実機FBで反転 2026-07-22):
       ›=リングを右へ回す(左のカードが前面へ) / ‹=左へ回す(右のカードが前面へ) */
    var prevBtn = stage.querySelector('[data-nxl-prev]');
    var nextBtn = stage.querySelector('[data-nxl-next]');
    if (prevBtn)
      prevBtn.addEventListener('click', function () {
        self.lastUser = performance.now();
        self.rotateTo(self.frontIndex() + 1);
      });
    if (nextBtn)
      nextBtn.addEventListener('click', function () {
        self.lastUser = performance.now();
        self.rotateTo(self.frontIndex() - 1);
      });

    /* 自動回転の休止シグナル(ホバー/フォーカス)+可視判定 */
    stage.addEventListener('pointerenter', function (e) {
      /* タッチのenterはtap時にも発火しleaveが来ないことがある=hovered残留で
         モバイル自動回転が止まるためマウスのみ休止対象(2026-07-22) */
      if (!e.pointerType || e.pointerType === 'mouse') self.hovered = true;
    });
    stage.addEventListener('pointerleave', function () {
      self.hovered = false;
      self.lastUser = performance.now();
    });
    stage.addEventListener('focusin', function (e) {
      /* キーボード由来(:focus-visible)のみ休止。旧: 無条件focused=true→矢印クリック後に
         ボタンへフォーカスが残ると自動回転が永久停止する実バグ(2026-07-22オーナー報告・
         Playwright再現済)。クリック/タップ由来のフォーカスは4秒ルール(lastUser)に任せる */
      var fv = true;
      try {
        fv = e.target.matches(':focus-visible');
      } catch (err) {}
      self.focused = fv;
    });
    stage.addEventListener('focusout', function () {
      self.focused = false;
      self.lastUser = performance.now();
    });
    stage.__nxlRing = this;
    if (autoVis) autoVis.observe(stage);

    this.paint();
  }

  Ring.prototype.radius = function () {
    var w = this.ring.clientWidth || 320;
    /* PC(リング幅720px以上)は枠を目一杯使う(2026-07-22): 係数/上限を引き上げ。
       モバイル/タブレットは従来式のまま(スマホ版は現状が完璧=オーナー確認済) */
    if (w >= 720) return Math.min(470, w * 0.4);
    return Math.min(340, Math.max(180, w * 0.36));
  };

  Ring.prototype.frontIndex = function () {
    var i = Math.round(-this.theta / this.step) % this.n;
    return ((i % this.n) + this.n) % this.n;
  };

  Ring.prototype.paint = function () {
    var r = this.radius();
    var front = this.frontIndex();
    for (var i = 0; i < this.n; i++) {
      var angle = i * this.step + this.theta;
      var rad = (angle * Math.PI) / 180;
      var depth = Math.cos(rad); /* 1=前面, -1=背面 */
      var norm = (depth + 1) / 2;
      var c = this.cards[i];
      c.style.transform =
        'rotateY(' +
        angle +
        'deg) translateZ(' +
        r +
        'px) rotateY(' +
        -angle +
        'deg) scale(' +
        (0.8 + 0.2 * norm) +
        ')';
      c.style.opacity = String(0.4 + 0.6 * norm);
      c.style.zIndex = String(100 + Math.round(depth * 50));
      c.classList.toggle('nxl-card--front', i === front);
      c.tabIndex = i === front ? 0 : -1;
      c.setAttribute('aria-hidden', i === front ? 'false' : 'true');
      /* cta_click計測(nx-track=document capture)は前面カードのみ+ドラッグ中は外す:
         captureが先に走るためドラッグ解放クリックでも発火してしまう→moved>8の間は
         属性ごと剥がして偽クリックを構造的に遮断(解放後の最初のglide paintで復元) */
      var suppress = this.dragging && this.moved > 8;
      if (i === front && !suppress) c.setAttribute('data-nx-cta', c.getAttribute('data-nx-cta-id') || '');
      else c.removeAttribute('data-nx-cta');
    }
    /* 前面切替の瞬間に日数チップをポップ(2026-07-22 提案④。初回/REDUCEDは発火なし) */
    if (front !== this.lastFront) {
      if (this.lastFront >= 0 && !REDUCED) {
        var chip = this.cards[front].querySelector('.nxl-card__size');
        if (chip) {
          chip.classList.remove('nxl-chip-pop');
          void chip.offsetWidth; /* アニメ再スタート用リフロー */
          chip.classList.add('nxl-chip-pop');
        }
      }
      this.lastFront = front;
    }
    /* トラックを-r奥へ: 前面カードの遠近拡大率を1.0(等倍)にして文字/画像をシャープに
       (旧: 前面がz=+rで視点に近づきGPU上で約1.34倍に引き伸ばされ全体がぼやけていた) */
    this.track.style.transform = 'translateZ(' + -r + 'px)';
  };

  Ring.prototype.glide = function () {
    var self = this;
    function frame() {
      self.velocity *= 0.93;
      self.theta += self.velocity;
      if (Math.abs(self.velocity) < 0.25) {
        self.raf = null;
        self.snap();
        return;
      }
      self.paint();
      self.raf = requestAnimationFrame(frame);
    }
    this.raf = requestAnimationFrame(frame);
  };

  Ring.prototype.snap = function () {
    var target = Math.round(this.theta / this.step) * this.step;
    this.animateTo(target);
  };

  Ring.prototype.rotateTo = function (index) {
    var current = this.theta;
    var target = -index * this.step;
    var diff = ((((target - current) % 360) + 540) % 360) - 180; /* 最短経路 */
    this.animateTo(current + diff);
  };

  Ring.prototype.animateTo = function (target) {
    var self = this;
    if (REDUCED) {
      this.theta = target;
      this.paint();
      return;
    }
    if (this.raf) cancelAnimationFrame(this.raf);
    var from = this.theta;
    var start = null;
    var dur = 450;
    function frame(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var ease = 1 - Math.pow(1 - t, 3);
      self.theta = from + (target - from) * ease;
      self.paint();
      if (t < 1) self.raf = requestAnimationFrame(frame);
      else self.raf = null;
    }
    this.raf = requestAnimationFrame(frame);
  };

  /* ライン入場: カードごとに transition-delay で階段状に立ち上げ→完了後クリア
     (delayを残すとドラッグ追従が遅れるため) */
  function enterLine(line) {
    var key = line.getAttribute('data-nxl-line');
    line.classList.add('nxl-in');
    if (REDUCED) return; /* reduceはCSSが静的グリッド化(リング不使用) */
    var stage = line.querySelector('.nxl-stage');
    if (!stage || rings[key]) return;
    var cards = stage.querySelectorAll('[data-nxl-card]');
    Array.prototype.forEach.call(cards, function (c, i) {
      c.style.transitionDelay = 60 + 90 * i + 'ms';
    });
    rings[key] = new Ring(stage); /* 初回paint→カードが隠し状態からリング位置へ遷移 */
    setTimeout(
      function () {
        Array.prototype.forEach.call(cards, function (c) {
          c.style.transitionDelay = '';
        });
      },
      60 + 90 * cards.length + 600,
    );
  }

  /* ============================================================
     2.5 情景パノラマ同期(2026-07-22 オーナー指示・提案1+2)
        全画面sticky層の3景(Blue裏=茶葉露/Pink裏=湖面/Premium裏=山霞)を
        各ラインパネル中心と画面中央の距離でクロスフェード(compareの縮小版)。
        パララックス: パネル通過中、背後の景だけ僅かに逆流(translateY=rel*5%。
        compareの translateY((p-c)*-7%) と同式・同方向の視覚言語)。
        REDUCEDはCSS静止フォールバック(1枚目のみ淡く)。
     ============================================================ */
  function initScenic(root) {
    if (REDUCED) return;
    var wrap = root.querySelector('[data-nxl-pan]');
    if (!wrap) return;
    var panes = [];
    Array.prototype.forEach.call(wrap.querySelectorAll('[data-nxl-pano]'), function (im) {
      var line = root.querySelector('[data-nxl-line="' + im.getAttribute('data-nxl-pano') + '"]');
      if (line) panes.push({ im: im, line: line });
    });
    if (!panes.length) return;
    var mobileMQ = window.matchMedia('(max-width: 749px)');
    var raf = 0;
    function dispose() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
    function tick() {
      raf = 0;
      /* DOM差し替え(エディタreload等)後の残留防止: 自己解除(compare/ToGOと同流儀) */
      if (!wrap.isConnected) {
        dispose();
        return;
      }
      var vh = window.innerHeight || 1;
      var rr = root.getBoundingClientRect();
      if (rr.bottom < -vh || rr.top > vh * 2) return; /* 遠景=描画スキップ(次のscrollで再開) */
      var peak = mobileMQ.matches ? 0.5 : 0.6; /* モバイルは既存情景の減光慣例に合わせ一段淡く */
      panes.forEach(function (pn) {
        var r = pn.line.getBoundingClientRect();
        var rel = (r.top + r.height / 2 - vh / 2) / vh; /* 0=パネル中心が画面中央 */
        var w = 1 - Math.min(1, Math.abs(rel) / 0.72); /* 中心±72vhで隣景へ長く溶ける */
        w = w * w * (3 - 2 * w); /* smoothstep=気づかない継ぎ目 */
        pn.im.style.opacity = (w * peak).toFixed(3);
        /* 画像はtop:-6%/height:112%の遊び内で±5%までドリフト(はみ出しゼロ) */
        var ty = Math.max(-5, Math.min(5, rel * 5));
        pn.im.style.transform = 'translateY(' + ty.toFixed(2) + '%) scale(1.06)';
      });
    }
    function onScroll() {
      if (!raf) raf = requestAnimationFrame(tick);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    tick(); /* 初期位置(深リンク着地含む)を即反映 */
  }

  /* ============================================================
     3. 診断モーダル
     ============================================================ */
  function initQuizModal(root) {
    var modal = root.querySelector('[data-nxl-q]');
    var opener = root.querySelector('[data-nxl-quiz-open]');
    if (!modal || !opener) return;
    document.body.appendChild(modal); /* transform祖先によるposition:fixed破壊を回避 */

    var panel = modal.querySelector('[data-nxl-q-panel]');
    var body = modal.querySelector('[data-nxl-q-body]');
    var result = modal.querySelector('[data-nxl-q-result]');
    var bar = modal.querySelector('[data-nxl-q-bar]');
    var sub = modal.querySelector('[data-nxl-q-sub]');
    var question = modal.querySelector('[data-nxl-q-question]');
    var opts = modal.querySelector('[data-nxl-q-opts]');
    var back = modal.querySelector('[data-nxl-q-back]');
    var closeBtn = modal.querySelector('[data-nxl-q-close]');
    var rname = modal.querySelector('[data-nxl-q-rname]');
    var rdesc = modal.querySelector('[data-nxl-q-rdesc]');
    var bars = modal.querySelector('[data-nxl-q-bars]');
    var more = modal.querySelector('[data-nxl-q-more]');
    var restart = modal.querySelector('[data-nxl-q-restart]');
    var answers = [];
    var idx = 0;

    function renderQuestion() {
      var q = QUESTIONS[idx];
      body.hidden = false;
      result.hidden = true;
      bar.style.width = (idx / QUESTIONS.length) * 100 + '%';
      sub.textContent = '質問 ' + q.id + ' / ' + QUESTIONS.length;
      question.textContent = q.text;
      opts.innerHTML = '';
      if (q.kind === 'rank') renderRank(q);
      else renderSingle(q);
      back.hidden = idx === 0;
      var f = opts.querySelector('button:not([disabled])');
      if (f) f.focus();
    }

    function next() {
      if (idx >= QUESTIONS.length - 1) renderResult();
      else {
        idx++;
        renderQuestion();
      }
    }

    function renderSingle(q) {
      var LETTERS = 'ABCD';
      q.options.forEach(function (o, oi) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nxl-q__opt';
        if (answers[idx] === oi) b.classList.add('is-picked'); /* 戻った時に前回回答を保持表示 */
        var mark = document.createElement('b');
        mark.textContent = LETTERS[oi] || String(oi + 1);
        b.appendChild(mark);
        b.appendChild(document.createTextNode(o.label));
        b.addEventListener('click', function () {
          answers[idx] = oi;
          next();
        });
        opts.appendChild(b);
      });
    }

    /* Q2: タップ順に1位→2位→3位を採番(再タップで解除・以降繰り上げ)。3位まで選ぶと次へが活性化 */
    function renderRank(q) {
      var picked = Array.isArray(answers[idx]) ? answers[idx].slice() : [];
      var wrap = document.createElement('div');
      wrap.className = 'nxl-q__rankopts';
      var foot = document.createElement('div');
      foot.className = 'nxl-q__rankfoot';
      var resetB = document.createElement('button');
      resetB.type = 'button';
      resetB.className = 'nxl-q__rankreset';
      resetB.textContent = 'リセット';
      var nextB = document.createElement('button');
      nextB.type = 'button';
      nextB.className = 'nxl-q__ranknext';
      nextB.textContent = '次へ →';
      function build(focusLabel) {
        wrap.innerHTML = '';
        q.options.forEach(function (label) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'nxl-q__opt nxl-q__opt--rank';
          b.setAttribute('data-rank-label', label);
          var pos = picked.indexOf(label);
          var mark = document.createElement('b');
          if (pos > -1) {
            b.classList.add('is-ranked');
            mark.textContent = pos + 1 + '位';
          } else {
            mark.textContent = '';
            mark.className = 'is-empty';
          }
          b.appendChild(mark);
          b.appendChild(document.createTextNode(label));
          b.addEventListener('click', function () {
            var p = picked.indexOf(label);
            if (p > -1) picked.splice(p, 1);
            else if (picked.length < 3) picked.push(label);
            build(label); /* 再構築後に同ボタンへフォーカス復元(トラップ維持) */
          });
          wrap.appendChild(b);
        });
        nextB.disabled = picked.length < 3;
        answers[idx] = picked.slice(); /* 編集を即同期=戻る→再訪でも最新順位を復元 */
        if (focusLabel != null) {
          var fb = wrap.querySelector('[data-rank-label="' + focusLabel + '"]');
          if (fb) fb.focus();
        }
      }
      resetB.addEventListener('click', function () {
        picked = [];
        build();
        var f0 = wrap.querySelector('button');
        if (f0) f0.focus();
      });
      nextB.addEventListener('click', function () {
        if (picked.length < 3) return;
        answers[idx] = picked.slice();
        next();
      });
      foot.appendChild(resetB);
      foot.appendChild(nextB);
      opts.appendChild(wrap);
      opts.appendChild(foot);
      build();
    }

    function renderResult() {
      var r = scoreQuiz(answers);
      var meta = LINE_META[r.rec];
      bar.style.width = '100%';
      body.hidden = true;
      result.hidden = false;
      rname.textContent = meta.name;
      rname.className = 'nxl-q__rname nxl-q__rname--' + r.rec;
      rdesc.textContent = meta.desc;
      /* 度数バー: 必ず ブルー度→ピンク度→プレミアム度 の固定順(得点順に並べ替えない) */
      var total = r.scores.blue + r.scores.pink + r.scores.premium;
      bars.innerHTML = '';
      QTYPES.forEach(function (t) {
        var pct = total > 0 ? Math.round((r.scores[t] / total) * 100) : 0; /* ゼロ除算ガード */
        var row = document.createElement('div');
        row.className = 'nxl-q__brow nxl-q__brow--' + t;
        var lb = document.createElement('span');
        lb.className = 'nxl-q__blabel';
        lb.textContent = TYPE_LABELS[t];
        var track = document.createElement('span');
        track.className = 'nxl-q__btrack';
        var fill = document.createElement('span');
        fill.className = 'nxl-q__bfill';
        track.appendChild(fill);
        var val = document.createElement('span');
        val.className = 'nxl-q__bval';
        val.textContent = pct + '%';
        row.appendChild(lb);
        row.appendChild(track);
        row.appendChild(val);
        bars.appendChild(row);
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fill.style.width = pct + '%';
          });
        });
      });
      more.setAttribute('href', COMPARE_URLS[r.rec]);
      more.focus();
      track('nx_quiz_result', {
        quiz_line: r.rec,
        quiz_blue: r.scores.blue,
        quiz_pink: r.scores.pink,
        quiz_premium: r.scores.premium,
      });
    }

    function restartQuiz() {
      answers = [];
      idx = 0;
      renderQuestion();
    }

    var lastFocus = null;
    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('nxl-lock');
      restartQuiz(); /* renderQuestionが先頭選択肢へfocus=開始直後から回答操作できる */
      track('nx_quiz_start', {});
    }
    function closeModal() {
      modal.hidden = true;
      document.documentElement.classList.remove('nxl-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    opener.addEventListener('click', function (e) {
      e.preventDefault(); /* no-JS時は/collections#nc-quizへの素リンク */
      openModal();
    });
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') {
        closeModal();
        return;
      }
      if (e.key !== 'Tab') return;
      /* フォーカストラップ: パネル内で循環 */
      var focusables = panel.querySelectorAll('button, a[href]');
      var list = Array.prototype.filter.call(focusables, function (el) {
        return !el.hidden && el.offsetParent !== null && !el.disabled;
      });
      if (!list.length) return;
      var first = list[0],
        last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
    back.addEventListener('click', function () {
      idx = Math.max(0, idx - 1);
      renderQuestion(); /* answersは保持=前の回答がハイライト/順位で復元される */
    });
    restart.addEventListener('click', restartQuiz);
  }

  /* ============================================================
     boot
     ============================================================ */
  function boot() {
    var root = document.querySelector('[data-nxl-root]');
    if (!root) return;
    initQuizModal(root);
    initScenic(root);
    var lines = root.querySelectorAll('[data-nxl-line]');
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(lines, enterLine);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          enterLine(en.target);
          io.unobserve(en.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
    );
    Array.prototype.forEach.call(lines, function (l) {
      io.observe(l);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
